import { useEffect, useState } from "react";
import { FicheType } from "../../FicheType/FicheType";
import { MoreInfo } from "../../MoreInfo/MoreInfo";
import './FicheTopsportScholen.scss';

export const FicheTopsportScholen = (props) => {
    const [bodyItems, setBodyItems] = useState([]);
    const [headerItems, setHeaderItems] = useState([]);

    //Processs body items
    useEffect(() => {
        let items = props.processFicheItems(props.data.body.items);
        setBodyItems(items);

        const newHeaderItems = [];
        props.data.text.split('_').forEach(item => {
            if (item.length > 0) {
                newHeaderItems.push(<li>{item}</li>);
            }
        });
        setHeaderItems(newHeaderItems);
    }, [JSON.stringify(props.data.body.items)]);

    return (
        <div
            className={`c-fiche c-fiche-topsportschool ${props.data?.hasDetail ? "u-has-detail" : ""}`}
            onClick={() => {
                if (props.data?.hasDetail && props.openPopup) {
                    props.openPopup(props.data.urlSegment);
                }
            }}
            data-aos="fade-up"
        >
            <div>
                <FicheType type={props.data.title} />
                <header className="c-fiche__header">
                    <h2>
                        {props.dictionary.offer}
                    </h2>
                    <ul>
                        {headerItems}
                    </ul>
                </header>
                <div className="c-fiche__body">
                    <h2>
                        {props.dictionary.topSportsSchoolCoordinator}
                    </h2>
                    <ul>
                        {bodyItems}
                    </ul>
                </div>
                <MoreInfo
                    data={props.data}
                    openPopup={props.openPopup}
                    cta={props.dictionary.moreInfo}
                />
            </div>
        </div>
    );
}